import React, {Component} from 'react'

import TreeList from "./SelectTemplateDialog/TreeList"
import ExpandState from "./../ui/ExpandState"

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

import TemplateIcon from '@material-ui/icons/ListAlt'

import ErrorMessageDialog from "./../ui/ErrorMessageDialog"

import Cookie from "../Cookie"
import {config} from "../config"

import api from "../api.js"

/**
 * <SelectTemplateDialog onSelectTemplate = {template} onCancel = {}/>
 */

class SelectTemplateDialog extends Component {

	state = {
		templates: [],
		selected: undefined,
		dialog: undefined,
	}

	expandState = new ExpandState()

	componentDidMount() {
		api.templates.list()
			.then(response => {
				this.setState({
					templates: response["templates"]
				})
			})
			.catch(errorMessage => {
				this.setState({
					dialog: <ErrorMessageDialog
						message = {errorMessage}
						onClose = {this.props.onCancel}
					/>
				})
			})
	}

	render() {

		if (this.state.dialog) {
			return this.state.dialog
		}

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Выбрать шаблон
			</DialogTitle>

			<DialogContent>

				<TreeList
					items = {this.state.templates}
					selected = {this.state.selected}
					itemIcon = {<TemplateIcon />}
					onClickItem = {async template => {
						if (this.state.selected ? (this.state.selected.id === template.id) : false) {
							if (template.type.toString() === "0") { // dbl click folder
								template.expand = !template.expand
								this.expandState.set(template.id, template.expand)
								this.forceUpdate()
							} else { // dbl click template
								if (typeof this.props.onSelectTemplate === "function") {
									let response = await api.templates.get_template_items(this.state.selected.id)
									this.state.selected.items = response.items
									this.props.onSelectTemplate(this.state.selected)
								}
							}
						} else {
							this.setState({
								selected: template
							})
						}
					}}
				/>

			</DialogContent>

			<DialogActions>

				<Button
					disabled = {!(this.state.selected && (this.state.selected ? this.state.selected.type.toString() === "1" : false))}
					onClick = {async e => {
						e.stopPropagation()
						if (typeof this.props.onSelectTemplate === "function") {
							let response = await api.templates.get_template_items(this.state.selected.id)
							this.state.selected.items = response.items
							this.props.onSelectTemplate(this.state.selected)
						}
					}}
				>Выбрать</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancel === "function") {
							this.props.onCancel()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default SelectTemplateDialog
